export default __webpack_public_path__ + "static/media/quiz_bg.357bb468.png";